module.exports = __webpack_public_path__ + "static/media/qrCardSuyo.b0c7d9aa.png";